module.exports = __webpack_public_path__ + "img/icon-play-outline.f5519318.svg";